import { render, staticRenderFns } from "./LevelCard.vue?vue&type=template&id=37aa389c&scoped=true&"
import script from "./LevelCard.vue?vue&type=script&lang=js&"
export * from "./LevelCard.vue?vue&type=script&lang=js&"
import style0 from "./LevelCard.vue?vue&type=style&index=0&id=37aa389c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa389c",
  null
  
)

export default component.exports